import { ApiUtil, WindowHelper } from '@everfi/reactifi';
import { TokenStoreContextValue } from './TokenStore';

/**
 * Fetches a URL with auth error handling built in.
 * 403/404 → clears the token and redirects to the platform sign-out URL.
 * All other errors are rethrown.
 * Returns the parsed response, or undefined if a 403/404 triggered a redirect.
 */
export const loadWithAuthGuard = async <T = unknown>(
  url: string,
  tokenStore: TokenStoreContextValue,
  signOutUrl: string
): Promise<T | undefined> => {
  try {
    return (await ApiUtil.loadExternalData(url, tokenStore.currentToken, true)) as T;
  } catch (error) {
    const status = (error as { response?: { status?: number } }).response?.status;
    if (status !== undefined && [403, 404].includes(status)) {
      tokenStore.clearToken();
      WindowHelper.WindowHelperWrapper(window).redirect(signOutUrl);
    } else {
      throw error;
    }
  }
};
